/**
 *----------------------------------------------------------------------
 * Copyright (c) 2023 - 2024 Your Company
 *
 * <<description>>
 *
 * -----
 * @summary <<summary>>
 * @author: wmegel
 * -----
 * Created Date: 11/05/2023 - 14:58:44
 * -----
 * Last Modified: 4/07/2024 - 16:51:58
 * Modified By: wmegel
 * -----
 *----------------------------------------------------------------------
*/

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  fr: {
        translation: {
      appVersion: "Version 1.5.1",
      signinFormTitle: 'Connexion',
      invalidEmail: 'Email invalide',
      mdpMinLengtLength: 'Trop court !',
      requiredEmailField: 'Email requis',
      requiredPasswordField: 'Mot de passe requis',
      authenticationButton: 'SE CONNECTER',
      matchingPasswordError: 'Les mots de passe doivent être identiques',
      changePasswordFormHeader: 'Modification de mot de passe',
      submit: 'VALIDER',
      oldPasswordPlaceHolder: 'Ancien mot de passe',
      newPasswordPlaceHolder: 'Nouveau mot de passe',
      loginPlaceHolder: 'Identifiant',
      passwordPlaceHolder: 'Mot de passe',
      NotAuthorizedException: 'Identifiant ou mot de passe incorrect',
      forgetPasswordButtonTitle: 'Mot de passe oublié ?',
      passwordResetHeaderTitle: 'Réinitialisation du mot de passe',
      sendCodeButtonTitle: 'ENVOYER LE CODE',
      codeRequiredError: 'Code requis',
      codeMustBeNumber: 'Le code doit être un nombre',
      codeMustBeInteger: 'Le code doit être un nombre entier',
      codeMustBePositive: 'Le code doit être un nombre positif',
      codePlaceHolder: 'Code',
      codeNotReceivedForgetPassword: 'Vous n\'avez pas reçu le code ?',
      newCompaignButtonTitle: 'Nouvelle campagne',
      createCompaignTitle: 'Création de campagne',
      customerLoadFileStepTitle: 'Fichier client',
      checkSmsOrEmailtextStepTitle: 'Texte SMS / Email',
      continueButtonTitle: 'CONTINUER',
      cancelButtonTitle: 'ANNULER',
      finishStepButtonTitle: 'ENVOYER',
      requiredCompaignName: 'Nom de la campagne requis',
      durationRequiredError: 'Durée requise',
      durationMustBeNumber: 'La durée doit être un nombre',
      durationMustBeInteger: 'La durée doit être un nombre entier',
      compaignNamePlaceHolder: 'Nom de la campagne',
      compaignFileNbLines: 'Nombre de lignes détectées dans le fichier : ',
      compaignFileInvalidFile: 'Le contrôle du fichier a échoué, veuillez vérifier le format !',
      compaignFileInvalidLine: 'Format de fichier invalide : nombre invalide de colonnes sur la ligne ',
      gsmNonCompliant: "Au moins un caractère non compatible avec la norme GSM (marqué(s) en orange dans la prévisualisation) !",
      gsmNonCompliant2: "ATTENTION: Le nombre de SMS envoyés va augmenter !",
      durationPlaceHolder: 'Durée (entre 1 et 100 jours)',
      selectFileTitle: 'Merci de sélectionner un fichier client (format .csv)',
      updateMessageTitle: 'Le message envoyé par SMS ou email est prévisualisé ci-dessous. Pour modifier le texte, merci de saisir le nouveau texte dans le champs dédié.',
      buttonUploadTitle: 'Cliquer ici pour importer',
      compaignUploadBadRequest: 'Erreur dans l\'import du fichier',
      serverError: 'Le serveur distant ne répond pas',
      tryAgainButtonTitle: 'Essayer de nouveau',
      compaignFileMissedError: 'Fichier csv manquant',
      campaignPendingStatus: 'En attente',
      campaignRunningStatus: 'En cours',
      campaignClosedStatus: 'Clôturé',
      campaignInErrorStatus: 'En erreur',
      durationTitle: 'Durée',
      dayUnit: 'jours',
      campaignInformationTitle: 'Informations de la campagne',
      fromDate: 'Du',
      toDate: 'au',
      meterNumberTitle: 'Nombre de compteurs',
      campaignPerformanceTitle: 'Performance de la campagne',
      campaignPerformanceSending: 'Envois',
      campaignPerformanceMeterReading: 'Index saisis',
      sentSmsTitle: 'SMS envoyés',
      receivedSmsTitle: 'SMS reçus',
      sentEmailTitle: 'Email envoyés',
      receivedEmailTitle: 'Email reçus',
      indexEntredTitle: 'Total d\'index saisis',
      manually: 'Manuellement',
      byVoice: 'Vocal',
      byOcr: 'OCR / Scan',
      sentEmailErrorTitle: 'Email en erreur',
      sentSmsErrorTitle: 'SMS en erreur',
      fillRateTitle: 'Taux de réponse',
      downloadFileTitle: 'Téléchargement de résultats',
      generateButtonTitle: 'GENERER .csv',
      downloadButtonTitle: 'TÉLÉCHARGER',
      downloadCsvButtonTitle: 'TÉLÉCHARGER .csv',
      downloadOcrButtonTitle: 'TÉLÉCHARGER LES PHOTOS',
      generateFileStatusDate: 'Le dernier fichier a été généré le : ',
      statusInfoTitle: 'Information de statut',
      PREPARING: 'Campagne en cours de préparation...',
      PENDING: 'Import du fichier en cours',
      WAITING_START: 'Merci de patienter pendant que la campagne se lance.',
      ERR_TECH_MS_ADMIN_STARTING_CAMPAIGN_PROCESS_FAILED: 'Une erreur est survenue pendant le lancement de la campagne, merci de créer une nouvelle campagne.',
      ERR_TECH_MS_CAMPAIGN_FILE_NOT_UPLOADED: 'Le fichier n\'a pas été importé, merci de créer une nouvelle campagne.',
      ERR_TECH_MS_CAMPAIGN_REQUEST_DELETION_FAILED: 'La suppression de la campagne n\'a pas fonctionné',
      ERR_TECH_MS_ADMIN_NO_VALID_LINE_IN_INPUT_FILE: 'Fichier csv invalide, merci de créer une nouvelle campagne.',
      ERR_TECH_MS_ADMIN_PROCESS_FILE_FAILED: 'L\'intégration du fichier a échoué. Merci de créer une nouvelle campagne.',
      defaultCampaignCreationError: 'Une erreur est survenue, merci de créer une nouvelle campagne.',
      None: 'Une erreur est survenue, merci de créer une nouvelle campagne.',
      fileGeneratingTitle: 'Génération du fichier en cours...',
      accessDenied: 'Accès refusé',
      deleteCampaignButtontitle: 'Supprimer la campagne',
      logout:'Déconnexion',
      userLink:'[LIEN]',
      costAbout: 'Coûts: environ ',
      preview: 'Prévisualisation',
      unauthorizedActionSession: 'Vous n\'êtes pas autorisé à accéder à l\'espace administrateur',
        }
  },
  en: {
    translation: {
      appVersion: "Version 1.5.1",
      signinFormTitle: 'Sign in',
      invalidEmail: 'Invalid Email',
      mdpMinLengtLength: 'Too Short!',
      requiredEmailField: 'Required Email',
      requiredPasswordField: 'Required Password',
      authenticationButton: 'LOG IN',
      matchingPasswordError: 'Passwords must match',
      changePasswordFormHeader: 'Change password',
      submit: 'SUBMIT',
      oldPasswordPlaceHolder: 'Old password',
      newPasswordPlaceHolder: 'New Password',
      loginPlaceHolder: 'User',
      passwordPlaceHolder: 'Password',
      NotAuthorizedException: 'Incorrect username or password',
      forgetPasswordButtonTitle: 'Forgot Password ?',
      passwordResetHeaderTitle: 'Reset password',
      sendCodeButtonTitle: 'SEND CODE',
      codeRequiredError: 'required code',
      codeMustBeNumber: 'Code must me a number',
      codeMustBeInteger: 'Code must me an integer',
      codeMustBePositive: 'Code must be positive',
      codePlaceHolder: 'Code',
      codeNotReceivedForgetPassword: 'You have not received the code?',
      newCompaignButtonTitle: 'New campaign',
      createCompaignTitle: 'Create Compaign',
      customerLoadFileStepTitle: 'Customer file',
      checkSmsOrEmailtextStepTitle: 'SMS / Email text',
      continueButtonTitle: 'CONTINUE',
      cancelButtonTitle: 'CANCEL',
      finishStepButtonTitle: 'FINISH',
      requiredCompaignName: 'Required compaign name',
      durationRequiredError: 'Required duration',
      durationMustBeNumber: 'Duration must me a number',
      durationMustBeInteger: 'Duration must me an integer',
      compaignNamePlaceHolder: 'Campaign name',
      compaignFileNbLines: 'Number of lines detected in the file : ',
      compaignFileInvalidFile: 'File check failed, please check file format !',
      compaignFileInvalidLine: 'Invalid file format : number of fields is not correct on line ',
      gsmNonCompliant: "A least one character non compliant with GSM format (marked as orange in the previzualisation) !",
      gsmNonCompliant2: "ATTENTION: total of sms sent will increase !",
      durationPlaceHolder: 'Duration (between 1 and 100 days)',
      selectFileTitle: 'Please select a customer file (.csv format)',
      updateMessageTitle: 'The preview shows the SMS or email to be sent.To modify the text, \nplease set a new one in the form on the right (and see the result below)',
      buttonUploadTitle: 'click here to upload',
      compaignUploadBadRequest: 'Compaign upload Failed',
      serverError: 'remote server is not responding',
      tryAgainButtonTitle: 'Try again',
      compaignFileMissedError: 'csv file missed',
      campaignPendingStatus: 'Pending',
      campaignRunningStatus: 'Running',
      campaignClosedStatus: 'Closed',
      campaignInErrorStatus: 'In Error',
      durationTitle: 'Duration',
      dayUnit: 'days',
      campaignInformationTitle: 'Campaign informations',
      fromDate: 'From',
      toDate: 'To',
      meterNumberTitle: 'Meter number',
      campaignPerformanceTitle: 'Campaign performance',
      campaignPerformanceSending: 'Sending',
      campaignPerformanceMeterReading: 'Meter reading entered',
      sentSmsTitle: 'SMS sent',
      receivedSmsTitle: 'SMS received',
      sentEmailTitle: 'Email sent',
      receivedEmailTitle: 'Email received',
      indexEntredTitle: 'Total meter reading entered',
      manually: 'Manually',
      byVoice: 'By voice',
      byOcr: 'By OCR / Scan',
      sentEmailErrorTitle: 'Email in error',
      sentSmsErrorTitle: 'SMS in error',
      fillRateTitle: 'Fill rate',
      downloadFileTitle: 'Result download',
      generateButtonTitle: 'CSV GENERATE',
      downloadButtonTitle: 'DOWNLOAD',
      downloadCsvButtonTitle: 'CSV DOWNLOAD',
      downloadOcrButtonTitle: 'OCR DOWNLOAD',
      generateFileStatusDate: 'The last file was generated on the: ',
      statusInfoTitle: 'Status information',
      PREPARING: 'Preparing campaign ...',
      PENDING: 'Upload in progress ...',
      WAITING_START: 'Waiting for campaign to start ...',
      ERR_TECH_MS_ADMIN_STARTING_CAMPAIGN_PROCESS_FAILED: 'An error occured during campaign launch, please create a new campaign',
      ERR_TECH_MS_CAMPAIGN_FILE_NOT_UPLOADED: 'File not uploaded, please create a new campaign',
      ERR_TECH_MS_CAMPAIGN_REQUEST_DELETION_FAILED: 'Campaign deletion failed',
      ERR_TECH_MS_ADMIN_NO_VALID_LINE_IN_INPUT_FILE: 'Invalid csv file, please create a new campaign',
      ERR_TECH_MS_ADMIN_PROCESS_FILE_FAILED: 'File Process failed, please create a new campaign',
      defaultCampaignCreationError: 'An error occured, please create a new campaign',
      None: 'An error occured, please create a new campaign',
      fileGeneratingTitle: 'New file generation in Progress ...',
      accessDenied: 'Access denied',
      deleteCampaignButtontitle: 'Delete campaign',
      logout:'Logout',
      userLink:'[USER LINK]',
      costAbout: 'Cost: about ',
      preview: 'Preview',
      unauthorizedActionSession: 'Vous n\'êtes pas autorisé à accéder à l\'espace administrateur',
    }
  },
  es: {
    translation: {
      appVersion: "Versión 1.5.1",
      signinFormTitle: 'Conectarse',
      invalidEmail: 'Dirección de correo electrónico no válida',
      mdpMinLengtLength: 'Contraseña demasiado corto',
      requiredEmailField: 'Dirección de correo electrónico necesario',
      requiredPasswordField: 'Contraseña necesaria',
      authenticationButton: 'CONECTARSE',
      matchingPasswordError: 'Las contraseñas deben ser idénticas',
      changePasswordFormHeader: 'Cambiar contraseña',
      submit: 'ENVIAR',
      oldPasswordPlaceHolder: 'Contraseña antigua',
      newPasswordPlaceHolder: 'Nueva contraseña',
      loginPlaceHolder: 'Usuario',
      passwordPlaceHolder: 'Contraseña',
      NotAuthorizedException: 'Usuario o contraseña incorrectos',
      forgetPasswordButtonTitle: 'Contraseña olvidada',
      passwordResetHeaderTitle: 'Restablecer la contraseña',
      sendCodeButtonTitle: 'ENVIAR CODIGO',
      codeRequiredError: 'Codigo necesario',
      codeMustBeNumber: 'El codigo debe ser un número',
      codeMustBeInteger: 'El codigo debe ser un número entero',
      codeMustBePositive: 'El codigo debe ser un número positivo',
      codePlaceHolder: 'Codigo',
      codeNotReceivedForgetPassword: 'No ha recibido el codigo ?',
      newCompaignButtonTitle: 'Nueva campaña',
      createCompaignTitle: 'Crear una campaña',
      customerLoadFileStepTitle: 'Archivo de clientes',
      checkSmsOrEmailtextStepTitle: 'SMS / correo electrónico enviado',
      continueButtonTitle: 'SEGUIR',
      cancelButtonTitle: 'CANCELAR',
      finishStepButtonTitle: 'FINALIZAR',
      requiredCompaignName: 'Nombre de campaña necesario',
      durationRequiredError: 'Duración necesaria',
      durationMustBeNumber: 'Duración debe ser un número',
      indexEntredTitle: 'Total de lecturas entradas',
      manually: 'Entrada manual',
      byVoice: 'Lectura vocal',
      byOcr: 'By OCR / Scan',
      downloadCsvButtonTitle: 'DESCARGAR ARCHIVO',
      downloadOcrButtonTitle: 'DESCARGAR FOTOS',
      durationMustBeInteger: 'Duración debe ser un número entero',
      compaignNamePlaceHolder: 'Nombre de la campaña',
      compaignFileNbLines: 'Nombre de lignes détectées dans le fichier : ',
      compaignFileInvalidFile: 'Le contrôle du fichier a échoué, veuillez vérifier le format !',
      compaignFileInvalidLine: 'Format de fichier invalide : nombre invalide de colonnes sur la ligne ',
      gsmNonCompliant: "Au moins un caractère non compatible avec la norme GSM (marqué(s) en orange dans la prévisualisation) !",
      gsmNonCompliant2: "ATTENTION: Le nombre de SMS envoyés va augmenter !",
      durationPlaceHolder: 'Duración (de 1 a 100 dias)',
      selectFileTitle: 'Por favor seleccione un archivo de clientes (formato .csv)',
      updateMessageTitle: 'La vista previa muestra como sera visto el SMS / correo electrónico por el usuario. Para modificar el texto, por favor ingrese un nuevo texto en el campo dedicado',
      buttonUploadTitle: 'hacer clic aqui para cargar el archivo',
      compaignUploadBadRequest: 'Carga de archivo fallado',
      serverError: 'El servidor remoto no responde',
      tryAgainButtonTitle: 'Inténtalo de nuevo',
      compaignFileMissedError: 'Archivo de clientes perdido',
      campaignPendingStatus: 'Pendiente',
      campaignRunningStatus: 'En proceso',
      campaignClosedStatus: 'Cerrada',
      campaignInErrorStatus: 'Con error',
      durationTitle: 'Duración',
      dayUnit: 'dias',
      campaignInformationTitle: 'Informaciones de campaña',
      fromDate: 'De',
      toDate: 'Hasta',
      meterNumberTitle: 'Nombre de medidores',
      campaignPerformanceTitle: 'Rendimiento de la campaña',
      campaignPerformanceSending: 'Envios',
      campaignPerformanceMeterReading: 'Lecturas entradas',
      sentSmsTitle: 'SMS enviado',
      receivedSmsTitle: 'SMS recibidos',
      sentEmailTitle: 'Correo electrónico enviado',
      receivedEmailTitle: 'Correo electrónico recibidos',
      sentEmailErrorTitle: 'Correo electrónico erroneo',
      sentSmsErrorTitle: 'SMS erroneo',
      fillRateTitle: 'Tasa de respuesta',
      downloadFileTitle: 'Descargar resultados',
      generateButtonTitle: 'GENERAR UN ARCHIVO CSV',
      downloadButtonTitle: 'DESCARGAR',
      generateFileStatusDate: 'Se generó el ultimo archivo de clientes en: ',
      statusInfoTitle: 'Información de estado',
      PREPARING: 'Campaña en curso de elaboración...',
      PENDING: 'Descargando...',
      WAITING_START: 'En espera de creación de campaña...',
      ERR_TECH_MS_ADMIN_STARTING_CAMPAIGN_PROCESS_FAILED: 'Ha surgido un error durante el lanzamiento de la campaña, por favor crea une nueva campaña',
      ERR_TECH_MS_CAMPAIGN_FILE_NOT_UPLOADED: 'Archivo no cargado, por favor crea une nueva campaña',
      ERR_TECH_MS_CAMPAIGN_REQUEST_DELETION_FAILED: 'Supresión de campaña fallada',
      ERR_TECH_MS_ADMIN_NO_VALID_LINE_IN_INPUT_FILE: 'Archivo de clientes CSV invalido, por favor crea une nueva campaña',
      ERR_TECH_MS_ADMIN_PROCESS_FILE_FAILED: 'Tratamiento del archivo fallado, por favor crea une nueva campaña',
      defaultCampaignCreationError: 'Ha surgido un error, por favor crea une nueva campaña',
      None: 'Ha surgido un error, por favor crea une nueva campaña',
      fileGeneratingTitle: 'Nueva generación de archivo en curso...',
      accessDenied: 'Acceso denegado',
      deleteCampaignButtontitle: 'Suprimir la campaña',
      logout: 'Desconectarse',
      userLink: '[ENLACE DEL USUARIO]',
      costAbout: 'Costo : aproximadamente ',
      preview: 'Vista Previa',
      unauthorizedActionSession: 'Vous n\'êtes pas autorisé à accéder à l\'espace administrateur',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  
  .init({
    resources,
    fallbackLng: "en",
    keySeparator: true, // we do not use keys in form messages.welcome
    debug: true,
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    detection: {
      // order and from where user language should be detected
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    
      // keys or params to lookup language from
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
    
      // cache user language on
      caches: ['localStorage', 'cookie'],
      excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
    
      // optional expire and domain for set cookie
      cookieMinutes: 10,
    
      // optional htmlTag with lang attribute, the default is:
      htmlTag: document.documentElement
    }
  }, (err, t) => {
    if (err) {
      console.log(err);
        // navigator.language failed, hence it's using "en-US"
    }});

  export default i18n;
